module.exports = __webpack_public_path__ + "static/media/tour-thumb.888047fe.png";